import { createSelector } from '@ngrx/store';
import { IAppState } from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';

export const selectFeature = (state: IAppState) => state.eventQueryCommand;

export const eventQueryCommandSelector = createSelector(
  selectFeature,
  (state) => state?.command
);
